module.exports = __webpack_public_path__ + "static/img/ptfw_afsbcg_one.b263e10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ptfw_afsbcg_one.png
// module id = 6cww
// module chunks = 21